import React from "react";
import styled from "styled-components";

const OutlineContainer = styled.div`
  border: 2px dashed black;
  border-radius: 16px;
  width: 100%;
  padding: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
  }
`;
export interface DottedOutlineButtonProps {
  title: string;
  handleClick: () => void;
}

export default function DottedOutlineButton(props: DottedOutlineButtonProps) {
  return (
    <OutlineContainer onClick={props.handleClick}>
      {props.title}
    </OutlineContainer>
  );
}
